<template>
  <v-dialog
    v-model="dialog"
    width="600"
  >
    <v-card>
      <v-card-title class="justify-center title grey--text pt-5">
        {{steps[currentStep].title}}
      </v-card-title>
      <v-card-text>
        <v-card
          tile
          text
          height="300"
          class="d-flex pa-5"
        >
          <img :src="pictureLink" alt="Outfox AI" class="ma-auto">
        </v-card>
        <v-card
          tile
          text
          class="text-xs-center title grey--text"
          height="70"
        >
          {{steps[currentStep].description}}
        </v-card>
      </v-card-text>
      <v-card-actions class="justify-space-between">
        <v-btn
          color="primary"
          @click="previous"
        >
          Previous
        </v-btn>
        <div class="controls">
          <div class="v-item-group">
            <button
              v-for="n in 4"
              type="button"
              class="v-btn v-btn--icon v-btn--small v-carousel__controls__item theme--light"
              :class="activeClass(n - 1)"
              @click="setStep(n - 1)"
            >
              <div class="v-btn__content ">
                <v-icon style="font-size: 18px;">fiber_manual_record</v-icon>
              </div>
            </button>
          </div>
        </div>
        <v-btn
          color="primary"
          @click="next"
        >
          Next
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'SetupChecklistDialogSix',
    data () {
      return {
        dialog: true,
        currentStep: 0,
        steps: [
          {
            id: 0,
            title: 'Assign Outfox as Page Partner',
            description: 'Setting -> Page -> Assign Partner',
            picture: ''
          },
          {
            id: 1,
            title: 'Select role as Page advertiser',
            description: 'Role -> Page Advertiser -> Enter Outfox Business ID (1977783552541328)',
            picture: ''
          },
          {
            id: 2,
            title: 'Assign Outfox as Ad account Partner',
            description: 'Settings -> Ad Account -> Assign Partner',
            picture: ''
          },
          {
            id: 3,
            title: 'Select Ad role as Ad account advertiser ',
            description: 'Role -> Ad account advertiser -> Enter Outfox Business ID (1977783552541328)',
            picture: ''
          }
        ],
        interval: null
      }
    },
    mounted () {
      this.startInterval()
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    computed: {
      pictureLink () {
        return require(`@/assets/setup-checklist/dialog6-${this.currentStep + 1}.png`)
      }
    },
    methods: {
      startInterval () {
        this.interval = setInterval(() => {
          if (this.currentStep < 3) this.currentStep++
          else this.currentStep = 0
        }, 10000)
      },
      activeClass (id) {
        if (Number(this.currentStep) === Number(id)) return 'active'
        return ''
      },
      previous () {
        if (this.currentStep > 0) this.currentStep--
      },
      next () {
        if (this.currentStep < 3) this.currentStep++
      },
      setStep (step) {
        this.currentStep = step
      }
    },
    watch: {
      dialog (val) {
        if (!val) this.$emit('clearCurrentDialog')
      }
    }
  }
</script>

